import { render, staticRenderFns } from "./JobVacancy.vue?vue&type=template&id=798ad260&"
import script from "./JobVacancy.vue?vue&type=script&lang=js&"
export * from "./JobVacancy.vue?vue&type=script&lang=js&"
import style0 from "./JobVacancy.vue?vue&type=style&index=0&id=798ad260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports